import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IHttpClient } from '../http-client/http-client.interface';
import { HttpOptions } from '../http-client/http-options';

@Injectable({
  providedIn: 'root'
})
export class AngularHttpClientAdapter implements IHttpClient {
  constructor(private http: HttpClient) {}

  get<TResponse>(absoluteUrl: string, options?: HttpOptions): Observable<TResponse> {
    return this.http.get<TResponse>(absoluteUrl, this.convertToAngularOptions(options));
  }

  post<TResponse, TBody>(absoluteUrl: string, body: TBody, options?: HttpOptions): Observable<TResponse> {
    return this.http.post<TResponse>(absoluteUrl, body, this.convertToAngularOptions(options));
  }

  put<TResponse, TBody>(absoluteUrl: string, body: TBody, options?: HttpOptions): Observable<TResponse> {
    return this.http.put<TResponse>(absoluteUrl, body, this.convertToAngularOptions(options));
  }

  delete<TResponse>(absoluteUrl: string, options?: HttpOptions): Observable<TResponse> {
    return this.http.delete<TResponse>(absoluteUrl, this.convertToAngularOptions(options));
  }

  patch<TResponse, TBody>(absoluteUrl: string, body: TBody, options?: HttpOptions): Observable<TResponse> {
    return this.http.patch<TResponse>(absoluteUrl, body, this.convertToAngularOptions(options));
  }

  private convertToAngularOptions(options?: HttpOptions): object {
    if (!options) {
      return {};
    }

    const angularOptions: Record<string, unknown> = {};

    if (options.headers) {
      angularOptions.headers = new HttpHeaders(options.headers);
    }

    if (options.params) {
      angularOptions.params = new HttpParams({ fromObject: options.params });
    }

    if (options.responseType) {
      angularOptions.responseType = options.responseType;
    }

    if (options.withCredentials !== undefined) {
      angularOptions.withCredentials = options.withCredentials;
    }

    if (options.body) {
      angularOptions.body = options.body;
    }

    return angularOptions;
  }
}
